import styled from "styled-components";

export const ExplanationContainer = styled.div`
    width: 350px;
    height: auto;
    display: flex;
    flex-direction: row-reverse;
    gap: 1rem;
    padding: 1.5rem;
    box-sizing: border-box;
    border-radius: 12px;
    background-color: #fff;
    min-height: 160px;
    border: 2px solid #e5e7eb;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;
    position: relative;
    overflow: hidden;

    &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 28px rgba(2, 131, 34, 0.15);
        border-color: #028322;
    }

    &:hover ${() => ExplanationIcon} {
        transform: scale(1.1) rotate(5deg);
        box-shadow: 0 4px 12px rgba(2, 131, 34, 0.3);
    }

    @media screen and (max-width: 800px){
        width: 100%;
        min-height: 120px;
        padding: 1.25rem;
    }
`;

export const ExplanationIcon = styled.div`
    width: 56px;
    height: 56px;
    min-width: 56px;
    min-height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    background: linear-gradient(135deg, #028322 0%, #027220 100%);
    color: #fff;
    font-size: 1.5rem;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 8px rgba(2, 131, 34, 0.2);

    @media screen and (max-width: 800px){
        width: 48px;
        height: 48px;
        min-width: 48px;
        min-height: 48px;
        font-size: 1.25rem;
    }
`;

export const ExplanationTitle = styled.h2`
    font-size: 1.125rem;
    font-weight: 700;
    margin: 0;
    color: #1f2937;
    line-height: 1.3;
    @media screen and (max-width: 800px){
        font-size: 1rem;
    }
`;

export const ExplanationText = styled.p`
    font-size: 0.875rem;
    font-weight: 400;
    margin: 0;
    color: #6b7280;
    line-height: 1.6;
    @media screen and (max-width: 800px){
        font-size: 0.8rem;
    }
`;

export const ExplanationBody = styled.div`
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    box-sizing: border-box;
`;